import React from 'react';

import { get, map } from 'lodash';

import { TopBarSelect } from 'pages/Teachers/shared';

const renderValue = (section) => get(section, 'section_name');
const buildOptions = (sections) =>
  map(sections, (section) => ({
    value: section,
    label: section.section_name
  }));

const SectionSelect = ({ sections, selectedSection, setSelectedSection }) => {
  if (!selectedSection) {
    return null;
  }

  return (
    <TopBarSelect
      value={selectedSection}
      renderValue={renderValue}
      onChange={setSelectedSection}
      options={buildOptions(sections)}
    />
  );
};

export default React.memo(SectionSelect);
